export default __webpack_public_path__ + "static/media/ic_suspicious.fc5e97d3.svg";